import React, { useState, useEffect, Fragment, useRef } from "react"

import { Dropdown, DropdownButton } from "react-bootstrap"

const TagsFilterDropdown = ({ tagsApi, mainTagClick }) => {
	return (
		<DropdownButton id="dropdown-basic-button" size="sm" title="Tag Filter ">
			<Dropdown.Item
				href="#/action-1"
				key={`drop_filter_reset`}
				className="reset_filter_list"
				onClick={(e) => {
					e.preventDefault()
					mainTagClick(undefined)
				}}
			>
				<div className="box  boxControl4" style={{ backgroundColor: "white" }}></div>
				<span className="ml-10">Reset filter</span>
			</Dropdown.Item>
			<Dropdown.Item
				href="#/action-1"
				key={`drop_filter_unteged`}
				className="untaged_list"
				onClick={(e) => {
					e.preventDefault()
					mainTagClick("untaged")
				}}
			>
				<div className="box  boxControl4"></div>
				<span className="ml-10">Untagged docs</span>
			</Dropdown.Item>

			{tagsApi && tagsApi.hasOwnProperty("tags")
				? tagsApi.tags.map((item, i) => (
						<Dropdown.Item
							href="#/action-1"
							key={`drop_filter_${item.id}`}
							onClick={(e) => {
								e.preventDefault()
								mainTagClick(item.id)
							}}
						>
							<div className="box  boxControl4" style={{ backgroundColor: item.color_id }}></div>
							<span className="ml-10">{item.name}</span>
						</Dropdown.Item>
				  ))
				: null}
		</DropdownButton>
	)
}

export default TagsFilterDropdown
